<template>
  <div>
    <Card>
      <Row>
        <Button style="float: right; " @click="change = true" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加用户组</Button>
      </Row>
      <tables border search-place="bottom" v-model="tableData" :columns="columns"/>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getGroupsList"></page>
        </div>
      </div>
      <Drawer
        :title="changeTitle"
        v-model="change"
        width="692"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="85" :rules="ruleValidate">
          <form-item label="用户组名称" prop="name">
            <i-input v-model="formItem.name" placeholder=""></i-input>
          </form-item>
          <form-item label="关联用户" prop="user_set">
            <transfer
              :data="no_select_user"
              :target-keys="formItem.user_set"
              :list-style="listStyle"
              @on-change="userChange"
              filterable></transfer>
          </form-item>
          <form-item>
            <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
            <i-button style="margin-left: 8px" @click="change = false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import { getGroups, changeGroup, deleteGroup, GetALLUsers } from '@/api/user'
export default {
  name: 'group-manage',
  components: {
    Tables
  },
  data () {
    return {
      change: false,
      count: 1,
      size: 10,
      page: 1,
      changeTitle: '添加权限',
      columns: [
        { title: 'ID', key: 'id', align: 'center', minWidth: 70 },
        { title: '用户组名', key: 'name', align: 'center', minWidth: 100 },
        { title: '角色', key: 'roles_name', align: 'center', minWidth: 70 },
        {
          title: '操作',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.Edit(params)
                  }
                }
              }, '编辑'),
              h('Poptip', {
                props: {
                  confirm: true,
                  placement: 'bottom',
                  title: '你确定要删除吗?'
                },
                on: {
                  'on-ok': () => {
                    this.handleDelete(params)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  }
                }, '删除')
              ])
            ])
          }
        }
      ],
      tableData: [],
      changeLoadingShow: false,
      formItem: {
        id: 0,
        name: '',
        user_set: []
      },
      no_select_user: [],
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        name: [
          { required: true, message: '用户组名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    this.getGroupsList()
    this.getNoSelectUser()
  },
  methods: {
    Edit (params) {
      this.formItem.id = params.row.id
      this.formItem.name = params.row.name
      this.formItem.user_set = params.row.user_set
      this.change = true
    },
    handleSubmit (name) {
      let that = this.formItem
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeLoadingShow = true
          changeGroup(this.formItem, this.formItem.id).then(res => {
            this.$Notice.success({ title: '操作成功！' })
            that.id = 0
            that.name = ''
            that.user_set = []
            this.change = false
            this.getGroupsList()
          }).catch(res => {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({ title: '请检查输入框！' })
        }
        this.changeLoadingShow = false
      })
    },
    drawerClose () {
      let that = this.formItem
      that.id = 0
      that.name = ''
      that.user_set = []
    },
    handleDelete (params) {
      deleteGroup(params.row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getGroupsList()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    getGroupsList (value = 1) {
      this.page = value
      let params = {
        'size': this.size,
        'page': this.page
      }
      getGroups(params).then(res => {
        this.tableData = res.data.results
        this.count = res.data.count
      })
    },
    getNoSelectUser () {
      let that = this
      that.no_select_user = []
      GetALLUsers().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            that.no_select_user.push({
              key: result[i].id,
              label: result[i].name
            })
          }
        }
      })
    },
    userChange (newTargetKeys) {
      this.formItem.user_set = newTargetKeys
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
